import { FC } from 'react'
import { useTheme } from '@emotion/react'

// styles
import { styles } from './styles'

type ArtistSkeletonProps = {}

export const ArtistSkeleton: FC<ArtistSkeletonProps> = () => {
  const theme = useTheme()

  return (
    <div css={styles(theme).skeleton.main}>
      <div css={styles(theme).skeleton.avatar} />
      <div css={styles(theme).skeleton.description.main}>
        <div css={styles(theme).skeleton.description.name} />
        <div css={styles(theme).skeleton.description.username} />
      </div>
    </div>
  )
}

ArtistSkeleton.propTypes = {}
